'use strict';

var d3 = require('d3');
var _ = require('lodash');
var Scales = function Scales(params, data) {
  var yMin = d3.min(data, function (d) {
    return Math.min(d.fareToPlot);
  });
  var yMax = d3.max(data, function (d) {
    return Math.max(d.fareToPlot);
  });
  var getSmartTicks = function getSmartTicks(yStart, yEnd) {
    //base step between nearby two ticks
    var step = Math.pow(10, Math.ceil(yEnd).toString().length - 1);

    //modify steps either: 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000...
    if (yEnd / step < 2) {
      step = step / 5;
    } else if (yEnd / step < 5) {
      step = step / 2;
    }

    //add one more step if the last tick value is the same as the max value
    //if you don't want to add, remove "+1"
    var slicesCount = Math.ceil((yEnd + 1) / step);
    return {
      startPoint: Math.ceil(yStart - step),
      endPoint: slicesCount * step,
      count: Math.min(10, slicesCount),
      //show max 10 ticks
      step: step
    };
  };

  //get the end value of Y axis and the number of ticks
  var yTicks = getSmartTicks(yMin, yMax);
  var x = d3.scale.ordinal().domain(_.map(data, 'departureDate')).rangeBands([5, params.width]);
  var y = d3.scale.linear().domain([yTicks.endPoint, yTicks.startPoint]).range([0, params.height]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;